module.exports = __webpack_public_path__ + "static/media/work (12).7eb85635.jpg";